export class Incident {

    incidentId: number;
    incidentName: string;
    incidentTimeInMilli: number;

    constructor(source: Incident) {
        this.incidentId = source.incidentId;
        this.incidentName = source.incidentName;
        this.incidentTimeInMilli = source.incidentTimeInMilli;
    }
}